import React, { useState } from "react";
import "./style.scss";
import uncheckedBox from "../../../assets/icons/unchecked_box_white.svg";
import checkedBox from "../../../assets/icons/checked_box_green.svg";

const Notification = () => {
  const [notify, setNotify] = useState({
    referralPurchase: false,
    payoutSubmission: false,
    payoutUpdate: false,
  });

  const handleNotification = (id) => {
    setNotify((prevState) => ({
      ...prevState,
      [id]: !prevState[id],
    }));
  };

  return (
    <div className="notification_container">
      <div className="notification_wrapper">
        <div className="header_wrapper">
          <h2>Notification Settings</h2>
          <p>
            We send notifications to the email specified during registration.
            Here you can choose the type of notifications you want to receive
          </p>
        </div>
        <div className="notification_checkboxes">
          <div
            className={`notify_options ${
              notify.referralPurchase ? "active" : ""
            }`}
            onClick={() => handleNotification("referralPurchase")}
          >
            <img
              src={notify.referralPurchase ? checkedBox : uncheckedBox}
              alt=""
            />
            <p>New Referral Purchase Email</p>
          </div>
          <div
            className={`notify_options ${
              notify.payoutSubmission ? "active" : ""
            }`}
            onClick={() => handleNotification("payoutSubmission")}
          >
            <img
              src={notify.payoutSubmission ? checkedBox : uncheckedBox}
              alt=""
            />
            <p>Prop Account Payout Submission Email</p>
          </div>
          <div
            className={`notify_options ${notify.payoutUpdate ? "active" : ""}`}
            onClick={() => handleNotification("payoutUpdate")}
          >
            <img src={notify.payoutUpdate ? checkedBox : uncheckedBox} alt="" />
            <p>Prop Account Payout Update Email</p>
          </div>
        </div>
        <div className="button_wrapper">
          <button className="standard-button">Save Changes</button>
        </div>
      </div>
    </div>
  );
};

export default Notification;
